export default __webpack_public_path__ + "static/media/partner-heroes-chained.47f39f82.png";